import { translateLang } from '@/data/i18n/translateLang'
import type { FormFieldType } from '@yige/ui'
import { computed } from 'vue'

export const columns = computed(() => {
  return [
    {
      title: translateLang('名称'),
      dataIndex: 'name',
      align: 'center',
      width: 350,
    },
    {
      title: translateLang('创建时间'),
      dataIndex: 'create_time',
      align: 'center',
      width: 180,
    },
    {
      title: translateLang('最近使用时间'),
      dataIndex: 'last_used_time',
      align: 'center',
      scopedSlots: { customRender: 'last_used_time' },
      width: 180,
    },
    {
      title: translateLang('过期时间'),
      dataIndex: 'expire_time',
      align: 'center',
      width: 180,
    },
    {
      title: translateLang('状态'),
      dataIndex: 'is_expired',
      align: 'center',
      scopedSlots: { customRender: 'is_expired' },
      width: 100,
    },
    {
      title: translateLang('操作'),
      dataIndex: 'action',
      align: 'center',
      scopedSlots: { customRender: 'action' },
      width: 150,
    },
  ]
})

export const fieldList = computed<FormFieldType[]>(() => [
  {
    formType: 'input',
    label: translateLang('名称'),
    key: 'name',
    fieldProps: {
      placeholder: translateLang('请输入令牌名称'),
      maxlength: 50,
    },
    required: true,
  },
  {
    formType: 'date',
    label: translateLang('过期时间'),
    key: 'expire_time',
    fieldProps: {
      placeholder: translateLang('请选择过期时间'),
    },
    required: true,
    slot: 'expire_time',
  },
])
